import { request } from '../request';

export async function addTalentCredential(
  userId: string,
  fileContent: File,
  credentialType: string,
  fileName: string,
): Promise<void> {
  const form = new FormData();

  form.append('file', fileContent);
  form.append('type', credentialType);
  form.append('fileName', fileName);

  await request.post<string>(`/v2/staff/${userId}/credentials`, form);
}

export async function removeTalentCredential(userId: string, filePath: string): Promise<void> {
  await request.delete<string>(`/v2/staff/${userId}/credentials`, {
    data: { filePath },
  });
}
